import { DatePipe } from '@angular/common';
import { Provider } from '@angular/core';
import { MediaItemScopeLabelPipe } from '@app/media-manager/pipes/media-item-scope-label.pipe';
import { BlobAccessTokenPipe } from '@app/shared/pipes/blob-access-token.pipe';
import { MonthLabelPipe } from '@app/shared/pipes/month-label.pipe';
import { OrderByUserSkillsPassportPipe } from '@app/shared/pipes/order-by-user-skills-passport.pipe';
import { TrackerOrderByPipe } from '@app/shared/pipes/order-by-user-tracker.pipe';
import { OrderByUserPipe } from '@app/shared/pipes/order-by-user.pipe';
import { OrderByPipe } from '@app/shared/pipes/order-by.pipe';
import { OutcomeLabelFromTypePipe } from '@app/shared/pipes/outcome-type-label.pipe';
import { SentenceCaseTextPipe } from '@app/shared/pipes/sentence-case-text.pipe';
import { SlugifyPipe } from '@app/shared/pipes/slugify.pipe';
import { StateLabelPipe } from '@app/shared/pipes/state-label.pipe';
import { StatusLabelPipe } from '@app/shared/pipes/status-label.pipe';
import { ToAlphaPipe } from '@app/shared/pipes/to-alpha.pipe';
import { TruncatePipe } from '@app/shared/pipes/truncate.pipe';
import { TypeLabelPipe } from '@app/shared/pipes/type-label.pipe';
import { UserAccountStatusPipe } from '@app/shared/pipes/user-account-status.pipe';
import { UserTypePipe } from '@app/shared/pipes/user-type.pipe';
import { WeekDayLabelPipe } from '@app/shared/pipes/week-day-label.pipe';

export function provideGlobalPipes (): Provider[] {
	return [
		BlobAccessTokenPipe,
		DatePipe,
		MediaItemScopeLabelPipe,
		MonthLabelPipe,
		OrderByPipe,
		OrderByUserPipe,
		OrderByUserSkillsPassportPipe,
		OutcomeLabelFromTypePipe,
		SentenceCaseTextPipe,
		SlugifyPipe,
		StateLabelPipe,
		StatusLabelPipe,
		ToAlphaPipe,
		TrackerOrderByPipe,
		TruncatePipe,
		TypeLabelPipe,
		UserAccountStatusPipe,
		UserTypePipe,
		WeekDayLabelPipe,
	];
}